import globalAxios from '../../../util/Api';
import {
  GET_CONSULTANTS,
  GET_CONSULTANT_PROJECTS,
  UPDATE_PROJECT_TIME,
  GET_PROJECT_ACTIVITIES,
  GET_PUBLIC_HOLIDAYS,
  ERROR,
  START_LOADING,
  STOP_LOADING
} from './types';
import { LogoutAction } from '../../../actions';
import numeral from 'numeral';
import 'numeral/locales/de';

export const GetConsultants = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/time_registrations/search_consultants`)
      .then(resultSet => {
        if (resultSet) {
          dispatch({ type: GET_CONSULTANTS, payload: resultSet.data.consultants })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}

export const GetConsultantProjects = (userId, month, year) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/time_registrations`, {
      params: {
        user_id: userId,
        month: month,
        year: year
      }
    }).then(resultSet => {
      if (resultSet) {
        dispatch({ type: STOP_LOADING })
        dispatch({ type: GET_CONSULTANT_PROJECTS, payload: resultSet.data })
      }
    }).catch(err => {
      dispatch({ type: STOP_LOADING })
      if (err.response)
        if (err.response.status === 401) {
          dispatch(LogoutAction())
        }
    })
  }
}

export const CreateProjectHours = (hour, date, projectId, userId, month, year, cbFailure) => {
  numeral.locale('de');
  let bodyFormData = new FormData();
  bodyFormData.append('project[project_times_attributes][0][hours]', numeral(hour).value());
  bodyFormData.append('project[project_times_attributes][0][date]', date);
  bodyFormData.append('project[project_times_attributes][0][project_id]', projectId);
  bodyFormData.append('project[project_times_attributes][0][user_id]', userId);
  return (dispatch) => {
    dispatch({ type: START_LOADING });
    globalAxios().put(`/api/v1/time_registrations/${projectId}`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch(GetConsultantProjects(userId, month, year))
          dispatch({ type: UPDATE_PROJECT_TIME, payload: resultSet.data })
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response) dispatch({ type: ERROR, payload: err.response.data.errors })
        if (cbFailure) cbFailure();
      })
  }
}

export const UpdateProjectHours = (timeId, hour, date, projectId, userId, month, year, cbFailure) => {
  numeral.locale('de');
  let bodyFormData = new FormData();
  bodyFormData.append('project[project_times_attributes][0][id]', timeId);
  bodyFormData.append('project[project_times_attributes][0][hours]', hour === "" ? " " : numeral(hour).value());
  bodyFormData.append('project[project_times_attributes][0][date]', date);
  bodyFormData.append('project[project_times_attributes][0][project_id]', projectId);
  bodyFormData.append('project[project_times_attributes][0][user_id]', userId);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/time_registrations/${projectId}`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch(GetConsultantProjects(userId, month, year))
          dispatch({ type: UPDATE_PROJECT_TIME, payload: resultSet.data })
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response) dispatch({ type: ERROR, payload: err.response.data.errors })
        if (cbFailure) cbFailure();
      })
  }
}

export const UpdateProjectActivity = (projectId, userId, token, activity, timeId, month, year) => {
  let bodyFormData = new FormData();
  bodyFormData.append('project[project_times_attributes][0][project_id]', projectId);
  bodyFormData.append('project[project_times_attributes][0][user_id]', userId);
  bodyFormData.append('project[project_times_attributes][0][token]', token);
  bodyFormData.append('project[project_times_attributes][0][activity]', activity);
  bodyFormData.append('project[project_times_attributes][0][id]', timeId);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().put(`/api/v1/time_registrations/${projectId}`, bodyFormData)
      .then(resultSet => {
        if (resultSet) {
          dispatch(GetConsultantProjects(userId, month, year))
          // dispatch({type: UPDATE_PROJECT_TIME, payload: resultSet.data})
          dispatch({ type: STOP_LOADING })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}

export const GetProjectActivities = (projectId) => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/project_activities`, {
      params: {
        project_id: projectId
      }
    }).then(resultSet => {
      if (resultSet) {
        dispatch({ type: GET_PROJECT_ACTIVITIES, payload: resultSet.data.project_activities })
      }
    }).catch(err => {
      if (err.response) {
        console.log(err)
      }
    })
  }
}

export const GetPublicHolidays = (month, year) => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/public_holidays`, {
      params: {
        month: month,
        year: year
      }
    }).then(resultSet => {
      if (resultSet) {
        dispatch({ type: GET_PUBLIC_HOLIDAYS, payload: resultSet.data.public_holidays })
      }
    })
  }
}